/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetAttributesBucketName200ResponseAllOf
 */
export interface GetAttributesBucketName200ResponseAllOf {
    /**
     * Clear-text person attributes as key-value pairs. Attribute names (keys) may be at most 70 bytes long. Attribute values must be JSON-serializable and are limited to 64KiB.
     * @type {{ [key: string]: any; }}
     * @memberof GetAttributesBucketName200ResponseAllOf
     */
    result?: { [key: string]: any; };
}

/**
 * Check if a given object implements the GetAttributesBucketName200ResponseAllOf interface.
 */
export function instanceOfGetAttributesBucketName200ResponseAllOf(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetAttributesBucketName200ResponseAllOfFromJSON(json: any): GetAttributesBucketName200ResponseAllOf {
    return GetAttributesBucketName200ResponseAllOfFromJSONTyped(json, false);
}

export function GetAttributesBucketName200ResponseAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAttributesBucketName200ResponseAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function GetAttributesBucketName200ResponseAllOfToJSON(value?: GetAttributesBucketName200ResponseAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'result': value.result,
    };
}

